import {
  WORKSPACE_FOR_GROUP_QUERY,
  type WorkspaceForGroupResult
} from '@/gql/queries/workflow-cards.gql';
import { useWorkspaceFromQuery } from '@/hooks/useWorkspaceFromQuery';

export const useWorkspaceForGroup = (groupId: string) =>
  useWorkspaceFromQuery<WorkspaceForGroupResult, { groupId: string }>({
    query: WORKSPACE_FOR_GROUP_QUERY,
    id: groupId,
    variables: { groupId },
    select: data => data?.groupByRowId?.workflow?.workspace ?? null
  });
